export const ROLES = {
  CUSTOMER: 'ROLE_CUSTOMER',
  ADMIN: 'ROLE_ADMIN'
};

export const REDIRECTED_URL = {
  redirected_device_url: 'admin/device-detail/',
  device_detail: 'device-detail',
  device_detail_url: 'device-detail/'
}

export const DeviceStatus = {
  STATUS_PASS: 'PASS',
  STATUS_FAIL: 'FAIL'
};

export const BAD_CREDENTIALS = 'Bad credentials';

export const QUADRANT_ARR = ['A', 'B', 'C', 'D'];
export const QUADRANT = {
  A: 'A',
  B: 'B',
  C: 'C',
  D: 'D',
  ONE: '1',
  TWO: '2',
  THREE: '3',
  FOUR: '4'
};

export const DEFAULT_LAT = 40.81864624931215;
export const DEFAULT_LNG = -100.0753547082108;

export const FIRMWARE_FILE = 'firmwareFile';
export const REQUIRED = 'required';
export const UPLOAD_ALLOWED_FILE_FORMAT = 'txt';

export const FirmwareStatusCode = {
  0: 'Successful',
  1: 'Failed',
  2: 'In Progress'
};

export const MODAL_WIDTH = '650px';

export const ACTIVE_SOCKET_CONNECTION_FIRMWARE_VERSION = '2';
